import React from 'react'
import { NavLink } from 'react-router-dom'
import { History, Mail } from 'lucide-react'
import useIsMobile from '../hooks/useIsMobile'

// Coda (mail) prima di Storico, su richiesta (2026-08-12) — ordine di
// utilizzo: si guarda prima cosa è in coda, poi lo storico di ciò che è già
// stato lavorato.
const BASE_NAV_ITEMS = [
  { to: '/coda', label: 'Coda', icon: Mail },
  { to: '/storico', label: 'Storico', icon: History },
]

// Analytics rimosso dalla sidebar (2026-08-12): vivrà sul server admin
// interno, non in questo frontend. La rotta /analytics e la pagina restano
// intatte in App.jsx/pages/Analytics.jsx, solo irraggiungibili da qui.

// Colonna di navigazione a icone. Su schermi larghi è un rail verticale a
// sinistra; sotto la soglia mobile diventa una barra orizzontale in basso
// (pattern da app mobile), con il logo nascosto per lasciare spazio alle
// voci di navigazione. Il logo in alto porta allo Storico.
export default function Sidebar() {
  const isMobile = useIsMobile(720)
  const navItems = BASE_NAV_ITEMS

  return (
    <nav style={isMobile ? s.railMobile : s.rail} aria-label="Navigazione principale">
      {!isMobile && (
        <NavLink to="/storico" style={s.logoLink} aria-label="Jenia — Storico">
          <img src="/images/jenia-j-mark-color.png" alt="Jenia" style={s.logo} />
        </NavLink>
      )}

      <div style={isMobile ? s.itemsMobile : s.items}>
        {navItems.map(({ to, label, icon: Icon }) => (
          <NavLink
            key={to}
            to={to}
            title={label}
            style={({ isActive }) => ({
              ...(isMobile ? s.itemMobile : s.item),
              ...(isActive ? s.itemActive : {}),
            })}
          >
            <Icon size={20} strokeWidth={1.8} />
            {isMobile && <span style={s.itemLabel}>{label}</span>}
          </NavLink>
        ))}
      </div>
    </nav>
  )
}

const s = {
  rail: {
    width: 68,
    flexShrink: 0,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: 8,
    padding: '18px 0',
    background: '#FFFFFF',
    borderRight: '1px solid var(--hairline)',
  },
  railMobile: {
    width: '100%',
    flexShrink: 0,
    order: 2,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '6px 0',
    background: '#FFFFFF',
    borderTop: '1px solid var(--hairline)',
  },
  logoLink: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: 36,
    height: 36,
    marginBottom: 20,
  },
  logo: {
    width: 22,
    height: 22,
    objectFit: 'contain',
  },
  items: {
    display: 'flex',
    flexDirection: 'column',
    gap: 6,
  },
  itemsMobile: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    gap: 8,
    width: '100%',
  },
  item: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: 40,
    height: 40,
    borderRadius: 10,
    color: 'var(--text-3)',
    textDecoration: 'none',
    transition: 'background 120ms ease, color 120ms ease',
  },
  itemMobile: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    gap: 2,
    flex: 1,
    padding: '6px 0',
    borderRadius: 10,
    color: 'var(--text-3)',
    textDecoration: 'none',
    transition: 'background 120ms ease, color 120ms ease',
  },
  itemLabel: {
    fontSize: 10.5,
    fontWeight: 500,
  },
  itemActive: {
    background: 'var(--bg-subtle)',
    color: 'var(--jenia-magenta)',
  },
}
